// @fluentui/react@7.106.2
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
import { setVersion } from '@uifabric/set-version';
setVersion('@fluentui/react', '7.106.2');